// MYACLanding.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AnimatedCounter from "./components/AnimatedCounter";
import Testimonials from "./components/Testimonials";
import useIntersectionObserver from "./hooks/useIntersectionObserver";

export default function MYACLanding() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <>
      {/* HERO SECTION */}
      <section className={`zapier-hero ${isVisible ? 'fade-in' : ''}`}>
        <div className="container">
          <div className="hero-left">
            <h1 className="hero-title">
              Modern product engineering built for scale and impact
            </h1>
            <p className="lead">
              MYAC helps companies ship faster, reduce risk, and harness AI
              & cloud — so you deliver real business outcomes.
            </p>

            <div className="hero-cta">
              <Link to="/contact" className="btn btn-primary">
                Get in touch
              </Link>
              <Link to="/services" className="btn btn-ghost">
                Our services
              </Link>
            </div>
          </div>

          <div className="hero-right">
            <img
              src="/assets/landingpagehero.png"
              alt="Product Mockup"
              className="hero-img"
            />
          </div>
        </div>
      </section>

      {/* TRUSTED BY */}
      <section className="section light">
        <div className="container center">
          <p className="muted" style={{ marginBottom: 18 }}>
            Trusted by forward-thinking companies
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 36,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <img
              src="https://via.placeholder.com/120x40?text=Logo+1"
              alt="Logo 1"
              style={{ opacity: 0.8 }}
            />
            <img
              src="https://via.placeholder.com/120x40?text=Logo+2"
              alt="Logo 2"
              style={{ opacity: 0.8 }}
            />
            <img
              src="https://via.placeholder.com/120x40?text=Logo+3"
              alt="Logo 3"
              style={{ opacity: 0.8 }}
            />
            <img
              src="https://via.placeholder.com/120x40?text=Logo+4"
              alt="Logo 4"
              style={{ opacity: 0.8 }}
            />
          </div>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="section light">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">
                <AnimatedCounter end={1} suffix="+" />
              </div>
              <div className="stat-label">Projects Delivered</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">
                <AnimatedCounter end={98} suffix="%" />
              </div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">
                <AnimatedCounter end={2} suffix="+" />
              </div>
              <div className="stat-label">Happy Clients</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">
                <AnimatedCounter end={5} suffix=" Years" />
              </div>
              <div className="stat-label">Experience</div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURE GRID */}
      <section className="section alt">
        <div className="container">
          <h2 className="section-title">Why teams choose MYAC</h2>
          <p className="section-sub">
            We blend engineering, AI, and cloud expertise to deliver products
            that drive growth and impact.
          </p>

          <div className="grid-3 cards">
            <div className="card card-body center">
              <img
                src="/assets/lakehouse.png"
                alt="Cloud"
                className="icon-img"
              />
              <h3>Cloud Engineering</h3>
              <p>Modernize infrastructure and scale seamlessly.</p>
            </div>
            <div className="card card-body center">
              <img
                src="/assets/analytics.png"
                alt="AI"
                className="icon-img"
              />
              <h3>AI Solutions</h3>
              <p>Transform your business with machine learning.</p>
            </div>
            <div className="card card-body center">
              <img
                src="/assets/metadata.png"
                alt="DevOps"
                className="icon-img"
              />
              <h3>DevOps & Automation</h3>
              <p>Ship faster, reduce risk, and innovate reliably.</p>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <Testimonials />

      {/* CTA STRIP */}
      <section className="section light">
        <div className="container center">
          <h2 className="section-title">Ready to get started?</h2>
          <p className="section-sub">
            Let's talk about how MYAC can help your business scale.
          </p>
          <Link to="/contact" className="btn btn-primary">
            Contact us
          </Link>
        </div>
      </section>
    </>
  );
}